module.exports = __webpack_public_path__ + "img/bra_logo_branco.6b32e208.svg";